

/* IMAGE_URLS — replace with your hosted URLs if these don't resolve */
window.__resources = {
  appShot1: 'https://godsverse.org/wp-content/uploads/2026/05/lordslines-pick-skit.png',
  appShot2: 'https://godsverse.org/wp-content/uploads/2026/05/lordslines-pick-role.png',
  appShot3: 'https://godsverse.org/wp-content/uploads/2026/05/lordslines-practice-mode.png',
  appShot4: 'https://godsverse.org/wp-content/uploads/2026/05/lordslines-ai-reads.png',
  appShot5: 'https://godsverse.org/wp-content/uploads/2026/05/lordslines-practice-lines.png',
  productShot: 'https://godsverse.org/wp-content/uploads/2026/05/godsverse-pro-product-shot.jpg',
};



/* global React */
const {
  useState
} = React;

// ─────────────────────────────────────────────────────────
// Data
// ─────────────────────────────────────────────────────────

const DELIVERABLES = [{
  n: "01",
  title: "1,000+ Skits & Plays — Instant Library Access",
  desc: "Download every skit and play in the Godsverse library. Easter, Christmas, Black History, youth group, Sunday service, funny, plays — print, perform, no royalties.",
  value: "Value $23,195.59"
}, {
  n: "02",
  title: "LordsLines Pro — AI Rehearsal App",
  desc: "Your team rehearses at home. Pick a skit, choose a role, AI reads every other part aloud. 50 skits to start, more added monthly. Invite 25 of your cast members to use it at no extra cost.",
  value: "Value $1500/yr"
}, {
  n: "03",
  title: "Worship Backgrounds — Stills, Motions, Countdowns",
  desc: "Our complete still and motion backgrounds collection — welcome loops, sermon backgrounds, countdowns, pre-service visuals.",
  value: "Value $13,404.90"
}, {
  n: "04",
  title: "Directing Church Skits 101 — Video Course",
  desc: "A practical 100-minute video course for drama directors and volunteers. Casting, blocking, rehearsing, performance day — taught from the trenches.",
  value: "Value $99"
}, {
  n: "05",
  title: "Skit Planner",
  desc: "A pre-built calendar of the 15 occasions a typical church performs drama — so you can plan the year in one sitting. Plus we will also send you recommended skits to use at the beginning of each month.",
  value: "Value $29"
}];
const CALENDAR = [{
  m: "Jan",
  e: "New Year Sunday",
  sub: "Vision · Renewal"
}, {
  m: "Feb",
  e: "Black History Sunday",
  sub: "Heritage"
}, {
  m: "Feb",
  e: "Valentine's / Love",
  sub: "Youth"
}, {
  m: "Mar",
  e: "Lent Begins",
  sub: "Reflection"
}, {
  m: "Apr",
  e: "Palm Sunday",
  sub: "Major",
  major: true
}, {
  m: "Apr",
  e: "Easter Sunday",
  sub: "Major",
  major: true
}, {
  m: "May",
  e: "Mother's Day",
  sub: "Family"
}, {
  m: "May",
  e: "Pentecost",
  sub: "Holy Spirit"
}, {
  m: "Jun",
  e: "Father's Day",
  sub: "Family"
}, {
  m: "Aug",
  e: "Back-to-School",
  sub: "Children"
}, {
  m: "Oct",
  e: "Harvest / Reformation",
  sub: "Heritage"
}, {
  m: "Nov",
  e: "Thanksgiving",
  sub: "Gratitude"
}, {
  m: "Dec",
  e: "Advent (4 weeks)",
  sub: "Major",
  major: true
}, {
  m: "Dec",
  e: "Christmas Eve",
  sub: "Major",
  major: true
}, {
  m: "Any",
  e: "Baptism / Communion",
  sub: "Sacrament"
}];
const SKITS = [{
  t: "At the Foot of the Cross",
  cast: "8 actors",
  time: "12 min",
  cat: "Easter",
  cover: 1,
  orn: "✝"
}, {
  t: "Palm Branch Parade",
  cast: "6 kids",
  time: "8 min",
  cat: "Easter · Kids",
  cover: 2,
  orn: "❧"
}, {
  t: "The Last Supper",
  cast: "13 actors",
  time: "18 min",
  cat: "Easter",
  cover: 3,
  orn: "✦"
}, {
  t: "Jingle Bells… Literally",
  cast: "4 actors",
  time: "6 min",
  cat: "Christmas · Funny",
  cover: 4,
  orn: "❄"
}, {
  t: "DJ Kool Herc & the Beat of Change",
  cast: "5 actors",
  time: "10 min",
  cat: "Black History",
  cover: 5,
  orn: "♪"
}, {
  t: "The Mystery of the Temple Veil",
  cast: "7 actors",
  time: "14 min",
  cat: "Easter",
  cover: 6,
  orn: "✦"
}];
const MODULES = [{
  n: "01",
  t: "Choosing & Adapting Scripts",
  p: "Pick the right script, adapt it fast, and anchor it in Scripture — age, time, space, theme, actors."
}, {
  n: "02",
  t: "Casting Correctly",
  p: "Cast for gifts, comfort, and reliability — not just talent. Give actors room to grow into the role."
}, {
  n: "03",
  t: "Helping Non-Actors Act",
  p: "Natural dialogue, projection, pacing, pausing, tone — simple tools for nervous performers."
}, {
  n: "04",
  t: "Directing Essentials",
  p: "Movement, entrances, exits, costume changes, and floor tape that keeps everything running smoothly."
}, {
  n: "05",
  t: "Rehearsal Planning",
  p: "Balance time, prep, and focus. One vs. multiple rehearsals, warmups, and how much script to run."
}, {
  n: "06",
  t: "Props, Costumes & Sets on a Budget",
  p: "Sheets, cardboard, foil, paint. Use what you have, plan ahead, and prep parents for forgotten costumes."
}, {
  n: "07",
  t: "Directing Kids vs. Teens vs. Adults",
  p: "Different needs, different motivations, different management. What works for each age group."
}, {
  n: "08",
  t: "Body Language & Expression",
  p: "Acting visually so the audience gets it even when they miss the words. Faces, hands, open posture."
}, {
  n: "09",
  t: "Lines",
  p: "Memorizing through deadlines, backup plans for forgotten lines, and what to do when something goes wrong."
}];
const TESTIMONIALS = [{
  stars: 5,
  quote: "Delightfully funny and yet it shares such an inspirational message! Can't wait to perform it at our upcoming Light Up the Night holiday show at the Community Zone in Lewisburg on December 15, 2025, at 7 PM!",
  name: "Lisa Rae Johnson",
  role: "Milton, Pennsylvania",
  initials: "LJ"
}, {
  stars: 5,
  quote: "I adapted the play to fit our needs and it was wonderful! I added a scene in the beginning involving Rudolph, to have another character, and to explain Santa's sudden memory loss. It turned out fantastic! We performed it for our church congregation for our Christmas program. The kids did a wonderful job!!!",
  name: "Melanie Bunyea",
  role: "Mequon, Wisconsin",
  initials: "MB"
}, {
  stars: 5,
  quote: "I am very impressed with the simplicity of the story portrayed in this short skit. There's depth to some of the lines and thought provoking. I hope my audience will hear and that they will be encouraged in that in grief there is HOPE even when hope feels buried.",
  name: "Elaine Hurst",
  role: "Martensville, Saskatchewan",
  initials: "EH"
}, {
  stars: 5,
  quote: "This is an amazing script! I am excited to see what God will do through this skit during our Easter morning worship service!",
  name: "Beverly Rauch",
  role: "Loganton, Pennsylvania",
  initials: "BR"
}, {
  stars: 5,
  quote: "I read it thru with the kiddos in Sunday and they are super excited to do it! We start rehearsals this Sunday. I really like it. The parts are easy enough for them to remember too.",
  name: "Sibyl Bomer",
  role: "Chicago, Illinois",
  initials: "SB"
}, {
  stars: 5,
  quote: "My girls and I are using it at a woman's conference in March. We all really like the balance of humor and also the great message it brings out.",
  name: "Karen Yoder",
  role: "Wooster, Ohio",
  initials: "KY"
}, {
  stars: 5,
  quote: "Wonderful play! Strong message. Appreciate downloading for quick delivery and editable doc to adjust for my cast.",
  name: "Judy Byce",
  role: "Bellevue, Washington",
  initials: "JB"
}, {
  stars: 5,
  quote: "Just what I was searching for to use at our ladies' luncheon in April! Funny yet so many spiritual insights throughout!",
  name: "Thelma Steele",
  role: "Sylvania, Georgia",
  initials: "TS"
}, {
  stars: 5,
  quote: "Meaningful, short and fun to tell others about Easter!",
  name: "Pam Runge",
  role: "Waconia, Minnesota",
  initials: "PR"
}];
const FAQS = [{
  q: "What exactly do I get for $99?",
  a: "Everything: 1,000+ skits and plays in the Godsverse library, the LordsLines Pro rehearsal app (50 skits to start, more added monthly) plus 30 invites for your cast to use the app, the full backgrounds collection, the Directing Church Skits 101 video course, and the Annual Drama Calendar PDF. One annual price covers it all."
}, {
  q: "Why is it so cheap? What's the catch?",
  body: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, "Honest answer: there isn't one. We made it affordable on purpose."), /*#__PURE__*/React.createElement("blockquote", {
    className: "faq-verse"
  }, "\"Each of you should use whatever gift you have received to serve others, as faithful stewards of God's grace in its various forms.\"", /*#__PURE__*/React.createElement("cite", null, "\u2014 1 Peter 4:10")), /*#__PURE__*/React.createElement("p", null, "We believe doing church drama should be easy. Skits change lives \u2014 they engage the actors who rehearse them and the congregations who watch them. But too many churches do skits rarely, or not at all, because the work is too expensive and too hard."), /*#__PURE__*/React.createElement("p", null, "If we priced this at what it's worth \u2014 $40,000+ if you bought every piece individually \u2014 only the largest churches could afford it. That's not who we built this for. We built it for the volunteer drama director at the small church, the youth pastor running a Wednesday service on a $50 budget, the family church putting on its first Easter production."), /*#__PURE__*/React.createElement("p", null, "So we priced it where any church can say yes. That's the mission."))
}, {
  q: "Is this non-denominational?",
  a: "Yes. Every skit is rooted in scripture and written to work across traditions. We have churches from AME, Baptist, Pentecostal, non-denominational, Methodist, and Catholic backgrounds using the library every week."
}, {
  q: "Are the skits hard to perform? What about props?",
  a: "We design for real church teams. Most skits need no special props — just chairs, basic lighting, and your people. Cast sizes range from 2 to 25, and runtimes from 5 to 45 minutes. Every script tells you exactly what you need."
}, {
  q: "How does the LordsLines app help us rehearse?",
  a: "Pick a skit, choose your role, and the app reads every other character aloud with natural AI voices. Your actors practice on the bus, in the car, on lunch break — and show up to rehearsal already knowing their cues."
}, {
  q: "Can I cancel?",
  a: "Yes — anytime, no questions. And the 30-day guarantee means you can try the entire membership risk-free. If it's not for you, email us in the first 30 days for a full refund."
}, {
  q: "What if I'm new to directing?",
  a: "The Directing Church Skits 101 course is built exactly for you. 100 minutes of practical training: casting, rehearsing, performance day, and what to do when things go wrong. Watch it once and you're ahead of most directors."
}];

// ─────────────────────────────────────────────────────────
// Small visual primitives
// ─────────────────────────────────────────────────────────

const PlayIcon = ({
  size = 28,
  color = "#1A1410"
}) => /*#__PURE__*/React.createElement("svg", {
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: color
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 5v14l11-7z"
}));
const Stars = ({
  n = 5
}) => /*#__PURE__*/React.createElement("span", {
  className: "stars",
  "aria-label": `${n} out of 5 stars`
}, "★".repeat(n));
